import { Icon } from '@manychat/manyui'

import { FlowChartIconBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartIconBuilder'
import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { FlowChartIcon } from 'common/builder/components/chart/FlowChart/types/FlowChartIcon'
import { IInstagramNode } from 'common/builder/nodes/nodeInterfaces'

export function getInstagramNodeRightIcon(node: IInstagramNode): FlowChartIcon | null {
  const { reasonId, privateReply } = node

  if (reasonId) {
    return new FlowChartIconBuilder(Icon.Notification, sharedStyles.IconSizes.MEDIUM_LARGE)
      .withColor(sharedStyles.Colors.PRIMARY)
      .build()
  }

  if (privateReply) {
    return new FlowChartIconBuilder(Icon.TriggerFbComments, sharedStyles.IconSizes.MEDIUM_LARGE)
      .withColor(sharedStyles.Colors.PRIMARY)
      .build()
  }

  return null
}
